import { render } from "./PhysicianReviewForm.vue?vue&type=template&id=138423c6"
import script from "./PhysicianReviewForm.vue?vue&type=script&lang=js"
export * from "./PhysicianReviewForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__